import { render, staticRenderFns } from "./UploadEditor.vue?vue&type=template&id=d5f1168a&scoped=true&"
import script from "./UploadEditor.vue?vue&type=script&lang=js&"
export * from "./UploadEditor.vue?vue&type=script&lang=js&"
import style0 from "./UploadEditor.vue?vue&type=style&index=0&id=d5f1168a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f1168a",
  null
  
)

export default component.exports